<button class="directionToggleOnGrid pb-2" (click)="getDirection(cellValue)">Get Directions</button>
